'use client';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { RelatedKeyword } from '~/apis/search';

export const useStoredRelatedKeywords = (query: string, defaultData?: RelatedKeyword[]) => {
  const queryClient = useQueryClient();
  const queryKey = useMemo(() => ['relatedKeywords', query], [query]);
  const { data } = useQuery({
    queryKey,
    placeholderData: (prev) => prev,
  });

  useEffect(() => {
    if (!queryKey || !defaultData) return;
    queryClient.setQueryData(queryKey, defaultData);
  }, [queryClient, queryKey, defaultData]);

  return defaultData ?? (data as RelatedKeyword[]);
};
